module.exports = __webpack_public_path__ + "static/img/resource.42d4720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resource.png
// module id = qOWL
// module chunks = 3